import { Alert, Box, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

import { PageLayout } from "@/shared/components";
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";

import { DeviceHeader } from "../DeviceHeader";
import { DeviceTabRoutes } from "../DeviceTabRoutes";
import { DeviceTabs } from "../DeviceTabs";

export function Device() {
  const { deviceId } = useParams();
  const theme = useTheme();

  if (!deviceId) {
    return (
      <PageLayout title={`Roboto - Device`}>
        <Alert severity="error">Missing device id in path</Alert>
      </PageLayout>
    );
  }

  return (
    <PageLayout
      title={`Roboto - Device - ${deviceId}`}
      headerContentLeft={<DeviceHeader deviceId={deviceId} />}
    >
      <ErrorBoundary
        fallback={(props) => {
          if (props.error instanceof Error) {
            return <Alert severity="error">{props.error.message}</Alert>;
          }

          return (
            <Alert severity="error">
              Something went wrong. Please contact{" "}
              <a href="mailto:support@roboto.ai">support@roboto.ai</a> if this
              problem persists.
            </Alert>
          );
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
          }}
        >
          <DeviceTabs deviceId={deviceId} />
          <DeviceTabRoutes deviceId={deviceId} />
        </Box>
      </ErrorBoundary>
    </PageLayout>
  );
}
